import React from 'react';
import './AlumniAssociation.css';
import Footer from '../components/Footer';
import PageHeader from '../about/PageHeader';
import Navbar from '../components/navbar';

const Icons = {
  School: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>
  ),
  Groups: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
  ),
  Pin: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
  ),
  Briefcase: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
  ),
  Mic: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>
  ),
  Psychology: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
  ),
  Explore: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg>
  )
};

const AlumniAssociation = () => {
  const committee = [
    { name: "Prof. Sonu Gupta", role: "President" },
    { name: "Mr. Brijesh Pandey", role: "Vice President" },
    { name: "Mr. Santosh Jain", role: "Secretary" },
    { name: "Mr. Apurb Sinha", role: "Treasurer" },
    { name: "Mr. Nitin Singh", role: "Executive Member" },
    { name: "Mr. Prashant Nair", role: "Executive Member" },
    { name: "Mr. Prasahant Tiwari", role: "Joint Secretary" },
    { name: "Mr. Malav Shah", role: "Joint Treasurer" },
  ];

  const ecosystem = [
    { title: "Alumni Association", icon: <Icons.Groups />, desc: "The heart of our network, fostering lifelong connections and shared professional heritage." },
    { title: "Institute Guests", icon: <Icons.Pin />, desc: "Welcoming back our distinguished alumni to contribute to the institute's strategic vision." },
    { title: "Placement Assistance", icon: <Icons.Briefcase />, desc: "Leveraging our network's influence to secure elite career opportunities for the new generation." },
    { title: "Guest Lectures", icon: <Icons.Mic />, desc: "Knowledge sharing sessions led by industry pioneers from our alumni collective." },
    { title: "Career Counselling", icon: <Icons.Psychology />, desc: "Personalized strategic guidance to navigate the complexities of the modern corporate world." },
    { title: "Career Guidance", icon: <Icons.Explore />, desc: "Mapping trajectories and exploring emerging domains through peer-led insights." },
  ];

  return (
    <>
      <Navbar />
  
      <PageHeader
        title="Alumni Association"
        crumbs={[{ label: 'Home', href: '/' }, { label: 'Alumni Association' }]}
      />
      <div className="prestige-app-wrapper">
        <main>
          {/* Intro Section */}
          <section className="prestige-section-white">
            <div className="prestige-editorial-grid">
              <div className="prestige-grid-left">
                {/* h2 replaced with div */}
                <div className="prestige-heading">TIMSCDR's Everlasting <br />Pride and Presence.</div>
                <div className="prestige-icon-circle">
                  <Icons.School />
                </div>
              </div>
              <div className="prestige-grid-right">
                <p className="prestige-body-text">
                  An organization’s alumni are the reflection of its past, representation of its present and a link to its future.
                </p>
                <p className="prestige-body-text">
                  For an Institute like TIMSCDR, one of our colleges in Kandivali, the true worth of its activities, in the long run, is the success of its alumni. It makes the Institute proud to know that its alumni have achieved success in their endeavors and reached the highest positions in all fields – whether it is research, academics, industry, entrepreneurship, or management. To strengthen the link with alumni, TIMSCDR, one of the top 10 private MCA colleges in Mumbai, has formed a registered alumni association.
                </p>
                <p className="prestige-body-text">
                  The Alumni Association of TIMSCDR is registered under Maharashtra Sarvajanik Vishwasta Vyavastha, 1960 with the number 1013/2019.
                </p>
              </div>
            </div>
          </section>

          {/* Interaction Ecosystem Section */}
          <section className="prestige-section-muted">
            <div className="prestige-container">
              <header className="prestige-centered-header">
                {/* h2 replaced with div */}
                <div className="prestige-heading">Interaction Ecosystem</div>
                <p className="prestige-subtitle">A multi-faceted framework designed to bridge the gap between academic theory and professional mastery.</p>
              </header>
              <div className="prestige-bento-grid">
                {ecosystem.map((item, idx) => (
                  <div key={idx} className="prestige-editorial-card">
                    <div className="prestige-card-icon-wrapper">{item.icon}</div>
                    {/* h3 replaced with div */}
                    <div className="prestige-card-title">{item.title}</div>
                    <p className="prestige-card-desc">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Visual Summary Section */}
          <div className="prestige-visual-summary-wrapper">
            <header className="prestige-centered-header">
              <div className="prestige-heading">Visual Summary</div>
            </header>
            <div className="prestige-visual-card">
              <div className="prestige-diagram-content">
                {/* If you have the image, use this: */}
                <img 
                  src="/Alumni/Alumni_association.png" 
                  alt="Alumni Interaction Channels and Activities Diagram" 
                  className="prestige-diagram-img" 
                />
                {/* If the image is missing, the alt text styling in CSS will handle the look */}
              </div>
            </div>
          </div>

          {/* Governing Committee Section */}
          <section className="prestige-committee-section">
            {/* Header Section */}
            <div className="prestige-committee-header">
              <div className="prestige-title-wrapper">
                <h2 className="prestige-committee-title">Governing Committee</h2>
                <p className="prestige-committee-subtitle">The architects of our alumni ecosystem.</p>
              </div>
            </div>

            {/* Grid Section */}
            <div className="prestige-committee-grid">
              {committee.map((member, idx) => (
                <div key={idx} className="prestige-member-node">
                  <div className="prestige-member-name">{member.name}</div>
                  <span className="prestige-label-sm">{member.role}</span>
                </div>
              ))}
            </div>
          </section>
        </main>
      </div>
      <Footer />
    </>
  );
};

export default AlumniAssociation;